import { render, staticRenderFns } from "./project_basic_info.vue?vue&type=template&id=6e2df2e2&scoped=true"
import script from "./project_basic_info.vue?vue&type=script&lang=js"
export * from "./project_basic_info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2df2e2",
  null
  
)

export default component.exports